/* Sui Story — localStorage wishlist. Toggles hearts on cards/PDP, keeps the
   badge in sync, and renders the saved page by fetching /products/{handle}.js. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});
  var KEY = 'suistory_wishlist';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function notify(list) { document.dispatchEvent(new CustomEvent('suistory:wishlist:updated', { detail: { count: list.length, items: list } })); }
  function save(list) { localStorage.setItem(KEY, JSON.stringify(list)); notify(list); }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) { var l = get(); var i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.push(h); save(l); return l.indexOf(h) > -1; }

  S.wishlist = { get: get, has: has, toggle: toggle };

  function syncButtons(scope) {
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', has(b.getAttribute('data-product-handle')) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var on = toggle(b.getAttribute('data-product-handle'));
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  function sized(url, w) { if (!url) return ''; var u = url.indexOf('//') === 0 ? 'https:' + url : url; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function money(cents) { return '₹' + (cents / 100).toLocaleString('en-IN'); }
  function heart() { return '<svg class="icon" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>'; }

  function renderWishlistPage(wrap) {
    var grid = wrap.querySelector('[data-wishlist-grid]');
    var empty = wrap.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    var list = get();
    if (!list.length) { if (empty) empty.removeAttribute('hidden'); grid.innerHTML = ''; return; }
    if (empty) empty.setAttribute('hidden', '');
    grid.innerHTML = '';
    list.forEach(function (h) {
      fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = p.featured_image ? '<img src="' + sized(p.featured_image, 600) + '" alt="" width="600" height="750" loading="lazy">' : '';
        var card = document.createElement('article');
        card.className = 'product-card';
        card.innerHTML =
          '<a class="product-card__media media ratio-portrait" href="' + p.url + '">' + img + '</a>' +
          '<button class="product-card__wishlist" type="button" data-wishlist-toggle data-product-handle="' + p.handle + '" aria-pressed="true" aria-label="Remove">' + heart() + '</button>' +
          '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<p class="product-card__price">' + money(p.price) + '</p></div>';
        grid.appendChild(card);
      });
    });
  }

  function initPage(scope) {
    syncButtons(scope);
    var wrap = (scope || document).querySelector ? (scope || document).querySelector('[data-wishlist-page]') : null;
    if (wrap) renderWishlistPage(wrap);
  }

  document.addEventListener('suistory:page:init', function (e) { initPage(e.detail && e.detail.scope ? e.detail.scope : document); });
  document.addEventListener('suistory:wishlist:updated', function () {
    var wrap = document.querySelector('[data-wishlist-page]');
    if (wrap) renderWishlistPage(wrap);
  });

  if (document.readyState !== 'loading') { initPage(document); notify(get()); }
  else document.addEventListener('DOMContentLoaded', function () { initPage(document); notify(get()); });
})();
